export const config = {
  title: "John Sweeney Crye-Leike Real Estate Services",
  meta: {
    description:
      "John Sweeney and Crye-Leike Elite Realtors provide expert real estate services in Henderson, TN, and surrounding areas. Specializing in residential and commercial properties.",
    keywords: [
      "Real Estate Henderson TN",
      "Homes for Sale Henderson",
      "Crye-Leike Realtors",
      "John Sweeney Real Estate",
      "Tennessee Real Estate Services"
    ],
    author: "John Sweeney Crye-Leike Real Estate Services",
    canonicalUrl: "https://www.homesbybrentandjohn.com/",
  },
  sections: {
    header: {
      businessName: "John Sweeney Crye-Leike Real Estate Services",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner",
      heroSubtitle: "Expert Guidance in Buying and Selling Properties",
      learnAboutText: "Explore Our Listings",
      phoneNumber: "7316082589",
      phoneLabel: "(731) 608-2589",
      heroBackgroundImage:
        "https://images.marketleader.com/assets/75/2405075_40438439_f.jpg",
      cardData: [
        {
          title: "Residential Properties",
          description:
            "Find your dream home with our extensive listings and personalized service.",
        },
        {
          title: "Commercial Real Estate",
          description:
            "Explore commercial properties that suit your business needs.",
        },
        {
          title: "Expert Consultation",
          description:
            "Benefit from our deep knowledge of the local real estate market.",
        },
      ],
      description:
        "At John Sweeney Crye-Leike Real Estate Services, we are committed to providing exceptional real estate services in Henderson, TN. Whether you're buying or selling, our team is here to guide you every step of the way.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive real estate services tailored to meet your unique needs.",
      cards: [
        {
          title: "Home Buying Assistance",
          description:
            "Navigate the home buying process with confidence and ease.",
          imageSrc: "https://media.istockphoto.com/id/1403453245/photo/the-financiers-are-calculating-personal-taxes-for-their-customers.jpg?s=612x612&w=0&k=20&c=B0pOXB8IH0TEMsF8ztFno6ZrpACRCFrmCdV2NNkw_gc=",
          imageAlt: "Home Buying",
        },
        {
          title: "Property Selling Services",
          description:
            "Achieve the best value for your property with our expert selling strategies.",
          imageSrc: "https://media.istockphoto.com/id/1297933326/photo/asian-chinese-businessman-shaking-hands-with-chinese-couple-in-their-house.jpg?s=612x612&w=0&k=20&c=sRnZqsR7pn5kPNH_S8LMir-1z7fSTwYLy_R5raTGlag=",
          imageAlt: "Property Selling",
        },
        {
          title: "Market Analysis",
          description:
            "Receive accurate market evaluations to make informed decisions.",
          imageSrc: "https://media.istockphoto.com/id/2164504974/photo/two-business-men-meeting-and-looking-at-financial-data-charts-and-graphs-on-a-digital-tablet.jpg?s=612x612&w=0&k=20&c=DvLRwX3IXYNtHJxZ1aCzoCGkuRMzuMUo1CPlbVioDFQ=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Property Management",
        "Investment Consulting",
        "Relocation Services",
        "Real Estate Marketing",
        "Open House Coordination",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/75/2405075_normal.jpg",
        alt: "John Sweeney and Team",
      },
      aboutText: [
        "With years of experience in the real estate industry, John Sweeney and the Crye-Leike Elite Realtors team are dedicated to helping clients achieve their real estate goals.",
        "Our commitment to excellence and personalized service sets us apart in the Henderson, TN, real estate market.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "John Sweeney Crye-Leike Real Estate Services Logo",
      businessName: "John Sweeney Crye-Leike Real Estate Services",
      contact: {
        phone: "7316082589",
        phoneLabel: "(731) 608-2589",
        email: "john@crye-leike.com",
        website: "https://www.homesbybrentandjohn.com/",
        address: "113 Front St, Henderson, TN 38340",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/johnsweeneyrealestate/",
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "113 Front St, Henderson, TN 38340",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.123456789!2d-88.6412345!3d35.4432106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x887c123456789abc%3A0xabcdef1234567890!2s113%20Front%20St%2C%20Henderson%2C%20TN%2038340!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
